var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack392({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4,10.73V5H6a2.1,2.1,0,0,1,1,.16,1.25,1.25,0,0,1,.51.53,1.75,1.75,0,0,1,.2.87,1.61,1.61,0,0,1-.33,1.05,1.58,1.58,0,0,1-1,.51,1.37,1.37,0,0,1,.4.32,3.73,3.73,0,0,1,.49.73l.82,1.56H7.31L6.68,9.54a6.11,6.11,0,0,0-.55-.94,1,1,0,0,0-.36-.33,1,1,0,0,0-.48-.09H4.57v2.55Zm.62-3.2H5.91a1.61,1.61,0,0,0,.66-.11.82.82,0,0,0,.36-.33,1,1,0,0,0,.13-.53.91.91,0,0,0-.25-.68,1.07,1.07,0,0,0-.76-.25H4.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.7,10.73V5h3.39v.68H9.32V7.43h2.6V8.1H9.32v2H12.2v.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack392);
export default __webpack_public_path__ + "static/media/Symbol_pack_392.b4bc2db3c782222ce454d254ee09c614.svg";
export { ForwardRef as ReactComponent };